module.exports = __webpack_public_path__ + "img/productHSE_4.291415b2.png";